export default __webpack_public_path__ + "static/media/step2.fc138534.jpg";